module.exports = __webpack_public_path__ + "static/img/031治疗单-医生.bf1741e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/031治疗单-医生.jpg
// module id = O8Hv
// module chunks = 0